import { Injector, Signal, Type } from '@angular/core';

export interface HpDialogButton {
  label: string;
  /** Visual variant. Default: 'ghost' */
  variant?: 'primary' | 'accent' | 'ghost' | 'danger';
  /**
   * Static boolean OR an Angular Signal<boolean>.
   * Pass a WritableSignal / computed signal for reactive disabled state.
   */
  disabled?: boolean | Signal<boolean>;
  onClick: (ref: HpDialogRef) => void;
}

export interface HpDialogConfig<C = unknown> {
  title: string;
  /** Inputs passed directly to the content component via ngComponentOutletInputs. */
  inputs?: Partial<Record<string, any>>;
  buttons?: HpDialogButton[];
  /** CSS width of the dialog card. Default: '520px' */
  width?: string;
  /** CSS height of the dialog card. Unset by default (sizes to content, max 85vh). */
  height?: string;
  /** Whether backdrop click / Esc closes the dialog. Default: true */
  closable?: boolean;
  /**
   * Optional node injector from the calling component.
   * Required when the content component depends on services that are provided
   * at the component level (not root), e.g. `providers: [MyService]` on a parent component.
   */
  injector?: Injector;
}

export class HpDialogRef {
  private _closeFn: () => void;

  constructor(closeFn: () => void) {
    this._closeFn = closeFn;
  }

  close(): void {
    this._closeFn();
  }
}
